import getElementAttribute from '../accessors/get-element-attribute';
import getLiveElement from '../accessors/get-live-element';
import DEFAULT_OPTIONS from '../constants/default-options';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';
import setElementAttribute from './set-element-attribute';
import removeResponsiveClasses from '../helpers/remove-responsive-classes';

const removeResponsiveClass = ({ elementId, className, breakpoint, options = DEFAULT_OPTIONS }) => {
  const currentClass =
    (options.strategy === UPDATE_LIVE_ONLY
      ? getLiveElement(elementId).getAttribute('class')
      : getElementAttribute(elementId, 'class')) || '';
  const cleanedClass = removeResponsiveClasses({ currentClass, className, breakpoint });
  return setElementAttribute(elementId, 'class', cleanedClass, options);
};

export default removeResponsiveClass;
